// @flow

import type {
    CloseEBadgeButtonActionModalAction,
    EBadgeButtonActionFailedAction,
    EBadgeButtonActionStartAction,
    EBadgeButtonActionSuccessAction,
    EBadgeButtonActionThunkAction,
    OpenEBadgeButtonActionModalAction
} from "../eBadgeButtonAction";
import type {Caller} from "../../../components/QueryPage";
import type {StoreState} from "../../../reducers/combinedReducers";

export function openEBadgeButtonModalAction(registrationCode: string, actionType: string): OpenEBadgeButtonActionModalAction {
    return {
        type: "ebadge/SHOW_BUTTON_ACTION_MODAL",
        registrationCode: "" + registrationCode,
        actionType
    }
}

export function closeEBadgeButtonModalAction(actionType: string): CloseEBadgeButtonActionModalAction {
    return {
        type: "ebadge/HIDE_BUTTON_ACTION_MODAL",
        actionType
    }
}


function eBadgeButtonActionStartAction(registrationCode: string, actionType: string): EBadgeButtonActionStartAction {
    return {
        type: "ebadge/BUTTON_ACTION_START_ACTION",
        registrationCode,
        actionType
    };
}

function eBadgeButtonActionSuccessAction(registrationCode: string, actionType: string, data?: any): EBadgeButtonActionSuccessAction {
    return {
        type: "ebadge/BUTTON_ACTION_SUCCESS_ACTION",
        registrationCode,
        actionType,
        data
    }
}

function eBadgeButtonActionFailedAction(error: any, registrationCode: string, actionType: string): EBadgeButtonActionFailedAction {
    return {
        type: "ebadge/BUTTON_ACTION_FAILED_ACTION",
        registrationCode,
        error: typeof error === "string" ? error : Object.assign({}, error),
        actionType
    }
}


export function eBadgeButtonAction(registrationCode: string,
                                 caller: Caller,
                                 actionType: string,
                                 handle: (registrationCode: string, caller: Caller, authToken: string) => Promise<any>): EBadgeButtonActionThunkAction {

    return async (dispatch, getState) => {
        try {

            if (getState) {
                dispatch(eBadgeButtonActionStartAction(registrationCode, actionType));
                const state: StoreState = getState();
                const result: ?any = await handle(registrationCode, caller, state.loginUser.jwt);
                dispatch(eBadgeButtonActionSuccessAction(registrationCode, actionType, result));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {
            dispatch(eBadgeButtonActionFailedAction(e, registrationCode, actionType));
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/creators/eBadgeButtonActionCreator.js